module.exports = __webpack_public_path__ + "media/images/iconSettings__inactive--dark-6d92ce8e51d27c8f2c226071654fda08.png";